import React from "react";
import { CountryFlagLabel } from "../CountryFlagLabel";

export const CountryISOCodeField = ({ record, source }) => (
    <CountryFlagLabel iso={record && record[source]} />
);

CountryISOCodeField.defaultProps = {
    addLabel: true,
};
